import type { AvatarProps as MuiAvatarProps } from '@mui/material';
import { Avatar as MuiAvatar } from '@mui/material';

export type AvatarProps = MuiAvatarProps;

export const Avatar = MuiAvatar;
